import React from "react";
import classnames from "classnames";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardImg,
  CardTitle,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  UncontrolledTooltip
} from "reactstrap";

// core components
import ExamplesNavbar from "components/Navbars/ExamplesNavbar.js";
import Footer from "components/Footer/Footer.js";
import CompilerApi from '../api/CompilerApi';
import swal from 'sweetalert';
import Fade from 'react-reveal/Fade';

class RegisterPage extends React.Component {
  constructor(props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleName = this.handleName.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handleType = this.handleType.bind(this);
    this.handleDesc = this.handleDesc.bind(this);
  }
  state = {
    squares1to6: "",
    squares7and8: "",
    name:"",
    email:"",
    type:"",
    desc:"",
  };
  componentDidMount() {
    document.body.classList.toggle("register-page");
    document.documentElement.addEventListener("mousemove", this.followCursor);
  }
  componentWillUnmount() {
    document.body.classList.toggle("register-page");
    document.documentElement.removeEventListener(
      "mousemove",
      this.followCursor
    );
  }
  handleName(e){
    this.setState({
      name: e.target.value
    });
  };
  handleEmail(e){
    this.setState({
      email: e.target.value
    });
  };
  handleType(e){
    this.setState({
      type: e.target.value
    });
  };
  handleDesc(e){
    this.setState({
      desc: e.target.value
    });
  };
  handleSubmit(event) {
    //this.setState({showSpinner:true});
    event.preventDefault();
    var name = this.state.name;
    var email = this.state.email;
    var type=this.state.type;
    var desc=this.state.desc;
    console.log()
    if(name==="" || desc===""){
      swal("Error","Please enter name and description","error");
    }else{
      CompilerApi.submitBug(name,email,type,desc)
      .then((res) => {
        swal("Success","Thank You","success");
      })
      .catch((error) => {
        swal("Error","Internal Server Error","error");
        // this.setState({showSpinner:false});
        console.log(error);
      });
    }
  }
  followCursor = event => {
    let posX = event.clientX - window.innerWidth / 2;
    let posY = event.clientY - window.innerWidth / 6;
    this.setState({
      squares1to6:
        "perspective(500px) rotateY(" +
        posX * 0.05 +
        "deg) rotateX(" +
        posY * -0.05 +
        "deg)",
      squares7and8:
        "perspective(500px) rotateY(" +
        posX * 0.02 +
        "deg) rotateX(" +
        posY * -0.02 +
        "deg)"
    });
  };
  render() {
    return (
      <>
        <ExamplesNavbar />
        <div className="wrapper">
          <div className="page-header">
            <div className="page-header-image" />
            <div className="content">
              <Container>
                <Row>
                  <Col className="offset-lg-0 offset-md-6" lg="5" md="12">
                    <Fade big>
                    <div
                      className="square square-7"
                      id="square7"
                      style={{ transform: this.state.squares7and8 }}
                    />
                    <div
                      className="square square-8"
                      id="square8"
                      style={{ transform: this.state.squares7and8 }}
                    />
                    <Card className="card-register">
                      <CardHeader>
                        <CardImg
                          alt="..."
                          src={require("assets/img/square-purple-1.png")}
                        />
                        <CardTitle tag="h4">Report</CardTitle>
                      </CardHeader>
                      <CardBody>
                        <Form className="form">
                          <InputGroup
                            className={classnames({
                              "input-group-focus": this.state.fullNameFocus
                            })}
                          >
                            <span style={{color:'red' , fontSize:'1.3rem'}}>*</span>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="tim-icons icon-single-02" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              required
                              placeholder="Your Name"
                              type="text"
                              onChange={this.handleName}
                              onFocus={e =>
                                this.setState({ fullNameFocus: true })
                              }
                              onBlur={e =>
                                this.setState({ fullNameFocus: false })
                              }
                            />
                          </InputGroup>
                          <InputGroup
                            className={classnames({
                              "input-group-focus": this.state.emailFocus
                            })}
                          >
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="tim-icons icon-email-85" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              required
                              placeholder="Email"
                              type="email"
                              onChange={this.handleEmail}
                              onFocus={e => this.setState({ emailFocus: true })}
                              onBlur={e => this.setState({ emailFocus: false })}
                            /> 
                          </InputGroup>
                          <span id="email" style={{fontSize:'0.8rem' ,color:'#bb54f1',paddingLeft:'10px'}}><u>Why email?</u></span>
                            <UncontrolledTooltip placement="bottom" target="email">
                            Just in case if your description is not clear to us we will personally contact you via email to clarify the issue.
                            </UncontrolledTooltip>
                          <InputGroup 
                          className={classnames({
                            "input-group-focus": this.state.typeFocus
                          })}>
                            <span style={{color:'red' , fontSize:'1.3rem'}}>*</span>
                            <Input type="select" className="form-control" name="select" onChange={this.handleType} onFocus={e => this.setState({ typeFocus: true })} onBlur={e => this.setState({ typeFocus: false })}>
                              <option style={{color:"black"}}>Bug</option>
                              <option style={{color:"black"}}>Suggestion</option>
                            </Input>
                          </InputGroup>
                          <InputGroup
                            className={classnames({
                              "input-group-focus": this.state.passwordFocus
                            })}
                          >
                            <span style={{color:'red' , fontSize:'1.3rem'}}>*</span>
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="tim-icons icon-notes" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              required
                              onChange={this.handleDesc}
                              type="textarea"
                              onFocus={e =>
                                this.setState({ passwordFocus: true })
                              }
                              onBlur={e =>
                                this.setState({ passwordFocus: false })
                              }
                            />
                          </InputGroup>
                        </Form>
                      </CardBody>
                      <CardFooter style={{textAlign:"center"}}>
                        <Button className="btn-round" onClick={this.handleSubmit}  color="primary" size="lg">
                          Submit
                        </Button>
                      </CardFooter>
                    </Card>
                    </Fade>
                  </Col>
                </Row>
                <div
                  className="square square-1"
                  id="square1"
                  style={{ transform: this.state.squares1to6 }}
                />
                <div
                  className="square square-2"
                  id="square2"
                  style={{ transform: this.state.squares1to6 }}
                />
                <div
                  className="square square-3"
                  id="square3"
                  style={{ transform: this.state.squares1to6 }}
                />
                <div
                  className="square square-4"
                  id="square4"
                  style={{ transform: this.state.squares1to6 }}
                />
                <div
                  className="square square-5"
                  id="square5"
                  style={{ transform: this.state.squares1to6 }}
                />
                <div
                  className="square square-6"
                  id="square6"
                  style={{ transform: this.state.squares1to6 }}
                />
              </Container>
            </div>
          </div>
          <Footer />
        </div>
      </>
    );
  }
}

export default RegisterPage;
